import _classCallCheck from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _defineProperty from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldSet from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/classPrivateFieldSet.js";
import _classPrivateFieldGet from "/home/runner/work/web/web/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet.js";

function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }

function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }

import { selectedChanged } from "./video-track-list.js";
import { VideoRendition } from "./video-rendition.js";
import { addRendition as _addRendition, removeRendition as _removeRendition } from "./video-rendition-list.js";
var VideoTrackKind = {
  alternative: "alternative",
  captions: "captions",
  main: "main",
  sign: "sign",
  subtitles: "subtitles",
  commentary: "commentary"
};

var _selected = /*#__PURE__*/new WeakMap();

var VideoTrack = /*#__PURE__*/function () {
  function VideoTrack() {
    _classCallCheck(this, VideoTrack);

    _defineProperty(this, "id", void 0);

    _defineProperty(this, "kind", void 0);

    _defineProperty(this, "label", "");

    _defineProperty(this, "language", "");

    _defineProperty(this, "sourceBuffer", void 0);

    _classPrivateFieldInitSpec(this, _selected, {
      writable: true,
      value: false
    });
  }

  _createClass(VideoTrack, [{
    key: "addRendition",
    value: function addRendition(src, width, height, codec, bitrate, frameRate) {
      var rendition = new VideoRendition();
      rendition.src = src;
      rendition.width = width;
      rendition.height = height;
      rendition.frameRate = frameRate;
      rendition.bitrate = bitrate;
      rendition.codec = codec;

      _addRendition(this, rendition);

      return rendition;
    }
  }, {
    key: "removeRendition",
    value: function removeRendition(rendition) {
      _removeRendition(rendition);
    }
  }, {
    key: "selected",
    get: function get() {
      return _classPrivateFieldGet(this, _selected);
    },
    set: function set(val) {
      if (_classPrivateFieldGet(this, _selected) === val) return;

      _classPrivateFieldSet(this, _selected, val);

      if (val !== true) return;
      selectedChanged(this);
    }
  }]);

  return VideoTrack;
}();

export { VideoTrack, VideoTrackKind };